const documents = {
  name: 'Name',
  document: 'Document',
  type: 'Type',
  tags: 'Tags',
}


export default documents